/* PeakFlex sections · vanilla JS, no dependencies.
   Every section initialises on its own and again when edited in the theme editor. */
(function () {
  'use strict';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- drag to scroll with the mouse (touch already swipes natively) ---------- */
  function dragScroll(el) {
    if (el.__pfDrag) return; el.__pfDrag = true;
    var down = false, moved = false, startX = 0, startL = 0;
    function mark() { el.classList.toggle('is-scrollable', el.scrollWidth > el.clientWidth + 2); }
    mark(); window.addEventListener('resize', mark);
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || el.scrollWidth <= el.clientWidth + 2) return;
      down = true; moved = false; startX = e.clientX; startL = el.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 5) { moved = true; el.classList.add('is-drag'); }
      if (moved) { el.scrollLeft = startL - dx; e.preventDefault(); }
    });
    window.addEventListener('pointerup', function () {
      if (!down) return; down = false;
      if (!moved) return;
      var card = el.firstElementChild, left = el.scrollLeft, max = el.scrollWidth - el.clientWidth, dest = left;
      if (card) {
        var w = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(el).columnGap) || 16);
        var idx = left / w, target = left > startL ? Math.ceil(idx - 0.15) : Math.floor(idx + 0.15);
        dest = Math.max(0, Math.min(max, target * w));
      }
      el.scrollTo({ left: dest, behavior: 'smooth' });
      setTimeout(function () { el.classList.remove('is-drag'); }, 450);
    });
    el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  /* ---------- best sellers carousel arrows ---------- */
  function initProducts(root) {
    var track = $('.pf-bs [data-track]', root), prev = $('[data-prev]', root), next = $('[data-next]', root);
    if (!track || !prev || !next || track.__pfInit) return; track.__pfInit = true;
    function step() { var c = $('.pc', track); return c ? c.getBoundingClientRect().width + 16 : 300; }
    function sync() {
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      prev.parentNode.style.visibility = track.scrollWidth > track.clientWidth + 2 ? '' : 'hidden';
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  /* ---------- reviews: arrows and "Read more" ---------- */
  function initReviews(root) {
    var rv = $('[data-rv]', root);
    if (rv && !rv.__pfInit) {
      rv.__pfInit = true;
      var step = function () { var c = $('.rvc', rv); return c ? c.getBoundingClientRect().width + 16 : 200; };
      var p = $('[data-rv-prev]', root), n = $('[data-rv-next]', root);
      if (p) p.addEventListener('click', function () { rv.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (n) n.addEventListener('click', function () { rv.scrollBy({ left: step(), behavior: 'smooth' }); });
    }
    $$('.rvc', root).forEach(function (card) {
      var t = $('.rvc__t', card), b = $('.rvc__more', card);
      if (!t || !b || b.__pfInit) return;
      if (t.scrollHeight > t.clientHeight + 2) {
        b.__pfInit = true; b.hidden = false;
        b.addEventListener('click', function () {
          var open = card.classList.toggle('is-open');
          b.textContent = open ? (b.dataset.less || 'Show less') : (b.dataset.more || 'Read more');
        });
      }
    });
  }

  /* ---------- slideshow ---------- */
  function initSlides(root) {
    var box = $('[data-slide]', root);
    if (!box || box.__pfInit) return; box.__pfInit = true;
    var imgs = $$('img', box), i = 0, timer = null, pp = $('[data-pp]', box);
    var ms = parseInt(box.dataset.interval, 10) || 3200;
    if (imgs.length < 2) return;
    function show(k) { imgs[i].classList.remove('on'); i = (k + imgs.length) % imgs.length; imgs[i].classList.add('on'); }
    function play() { clearInterval(timer); timer = setInterval(function () { show(i + 1); }, ms); if (pp) { pp.setAttribute('aria-label', pp.dataset.lPause || 'Pause slideshow'); $('[data-pause]', pp).hidden = false; $('[data-play]', pp).hidden = true; } }
    function stop() { clearInterval(timer); timer = null; if (pp) { pp.setAttribute('aria-label', pp.dataset.lPlay || 'Play slideshow'); $('[data-pause]', pp).hidden = true; $('[data-play]', pp).hidden = false; } }
    if (pp) pp.addEventListener('click', function () { timer ? stop() : play(); });
    box.__pfShow = function (el) { var k = imgs.indexOf(el); if (k > -1) { stop(); show(k); } };
    RM ? stop() : play();
  }

  /* ---------- count-up numbers ---------- */
  function parseStat(t) { var m = t.match(/^([^0-9]*)([0-9]+(?:\.[0-9]+)?)(.*)$/); return m ? { pre: m[1], num: parseFloat(m[2]), dec: (m[2].split('.')[1] || '').length, post: m[3] } : null; }
  function initCount(root) {
    var els = $$('[data-count]', root).filter(function (el) { return !el.__pfInit; });
    if (!els.length || RM || !('IntersectionObserver' in window)) return;
    els.forEach(function (el) { el.__pfInit = true; el.dataset.final = el.textContent; var p = parseStat(el.textContent); if (p) el.textContent = p.pre + (0).toFixed(p.dec) + p.post; });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.disconnect();
        els.forEach(function (el) {
          var p = parseStat(el.dataset.final); if (!p) { el.textContent = el.dataset.final; return; }
          var t0 = null;
          (function frame(ts) {
            if (!t0) t0 = ts;
            var k = Math.min(1, (ts - t0) / 1500), e = 1 - Math.pow(1 - k, 3);
            el.textContent = p.pre + (p.num * e).toFixed(p.dec) + p.post;
            if (k < 1) requestAnimationFrame(frame); else el.textContent = el.dataset.final;
          })(performance.now());
        });
      });
    }, { threshold: 0.35 });
    io.observe(els[0].closest('.stats') || els[0]);
  }

  /* ---------- marquee speed in px per second ---------- */
  function initMarquee(root) {
    var mq = $('[data-pf-marquee]', root);
    if (!mq) return;
    var track = $('.mq__track', mq), set = $('.mq__set', mq), speed = parseFloat(mq.dataset.speed) || 42;
    function size() { if (set && track) track.style.animationDuration = Math.max(10, set.getBoundingClientRect().width / speed) + 's'; }
    size();
    if (!mq.__pfInit) { mq.__pfInit = true; window.addEventListener('resize', size); window.addEventListener('load', size); }
  }

  function initRoot(root) {
    if (!root) return;
    initProducts(root); initReviews(root); initSlides(root); initCount(root); initMarquee(root);
    $$('.cats, [data-track], [data-rv], [data-drag]', root).forEach(dragScroll);
  }

  /* ---------- size guide popup ---------- */
  var lastFocus = null;
  function sgEl() { return $('[data-pf-sg]'); }
  function openSG(from) {
    var sg = sgEl(); if (!sg) return false;
    lastFocus = from || document.activeElement;
    sg.hidden = false; document.body.classList.add('pf-sg-open');
    var x = $('.sg__x', sg); if (x) x.focus();
    return true;
  }
  function closeSG() {
    var sg = sgEl(); if (!sg || sg.hidden) return;
    sg.hidden = true; document.body.classList.remove('pf-sg-open');
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
  }
  document.addEventListener('keydown', function (e) {
    var sg = sgEl(); if (!sg || sg.hidden) return;
    if (e.key === 'Escape') closeSG();
    if (e.key === 'Tab') {
      var f = $$('button, a[href], input, [tabindex]:not([tabindex="-1"])', sg), first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- button actions ---------- */
  function cartEl() { return document.querySelector('cart-drawer') || document.querySelector('cart-notification'); }
  function addToCart(btn) {
    var id = btn.dataset.variantId, cart = cartEl();
    if (!id) { if (btn.dataset.url) window.location = btn.dataset.url; return; }
    btn.classList.add('pf-btn-busy');
    var fd = new FormData(); fd.append('id', id); fd.append('quantity', 1);
    if (cart && cart.getSectionsToRender) {
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
      if (cart.setActiveElement) cart.setActiveElement(btn);
    }
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: fd })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { window.location = btn.dataset.url || '/cart'; return; }
        if (cart && cart.renderContents) {
          cart.classList.remove('is-empty');
          cart.renderContents(res);
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'pf-button' });
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () { window.location = btn.dataset.url || '/cart'; })
      .finally(function () { btn.classList.remove('pf-btn-busy'); });
  }
  function openCart(btn) {
    var cd = document.querySelector('cart-drawer');
    if (cd && cd.open) { cd.classList.remove('is-empty'); cd.open(btn); }
    else window.location = btn.dataset.url || '/cart';
  }
  document.addEventListener('click', function (e) {
    var closer = e.target.closest('[data-size-close]');
    if (closer && closer.closest('[data-pf-sg]')) { closeSG(); return; }
    var b = e.target.closest('[data-pf-action]'); if (!b) return;
    var a = b.dataset.pfAction;
    if (a === 'size_guide') { e.preventDefault(); if (!openSG(b) && b.dataset.url) window.location = b.dataset.url; }
    else if (a === 'scroll') {
      var id = (b.getAttribute('href') || '').replace('#', ''), t = id && document.getElementById(id);
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: RM ? 'auto' : 'smooth', block: 'start' }); }
    }
    else if (a === 'add_to_cart') { e.preventDefault(); addToCart(b); }
    else if (a === 'open_cart') { e.preventDefault(); openCart(b); }
  });

  /* ---------- sticky bar: after the hero, hidden over the newsletter ---------- */
  var stickyIO = [];
  function initSticky() {
    stickyIO.forEach(function (io) { io.disconnect(); }); stickyIO = [];
    var bar = $('.pf [data-sticky]'); if (!bar) return;
    var btn = $('.sticky-cta__btn', bar), hero = $('.pf .hero'), news = $('.pf .news');
    var heroGone = false, newsIn = false;
    function sync() {
      var on = heroGone && !newsIn;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (btn) btn.tabIndex = on ? 0 : -1;
    }
    if (!('IntersectionObserver' in window)) { heroGone = true; sync(); return; }
    if (hero) {
      var a = new IntersectionObserver(function (en) { heroGone = !en[0].isIntersecting; sync(); }, { threshold: 0 });
      a.observe(hero); stickyIO.push(a);
    } else {
      var after = parseInt(bar.dataset.showAfter, 10) || 600;
      var onScroll = function () { heroGone = window.scrollY > after; sync(); };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }
    if (news) {
      var b = new IntersectionObserver(function (en) { newsIn = en[0].isIntersecting; sync(); }, { threshold: 0.15 });
      b.observe(news); stickyIO.push(b);
    }
  }

  /* ---------- dot grid: keep one continuous grid across neighbouring sections ---------- */
  function alignDots() {
    $$('.pf.pf-dots').forEach(function (el) {
      var top = el.getBoundingClientRect().top + window.scrollY;
      el.style.setProperty('--pf-dots-y', (-(top % 22)).toFixed(2) + 'px');
    });
  }

  function boot() {
    $$('[data-pf]').forEach(initRoot);
    initSticky(); alignDots();
    window.addEventListener('load', alignDots);
    window.addEventListener('resize', alignDots);
    if ('ResizeObserver' in window) new ResizeObserver(alignDots).observe(document.body);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  /* ---------- theme editor ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    initRoot($('[data-pf]', e.target)); initSticky(); alignDots();
  });
  document.addEventListener('shopify:section:unload', function () { setTimeout(function () { initSticky(); alignDots(); }, 0); });
  document.addEventListener('shopify:section:select', function (e) { if ($('[data-pf-sg]', e.target)) openSG(null); });
  document.addEventListener('shopify:section:deselect', function (e) { if ($('[data-pf-sg]', e.target)) closeSG(); });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    var scroller = el.closest('[data-track], [data-rv], [data-drag], .cats');
    if (scroller) scroller.scrollTo({ left: el.offsetLeft - scroller.offsetLeft - 16, behavior: 'smooth' });
    if (el.tagName === 'DETAILS') el.open = true;
    var slideBox = el.closest('[data-slide]'); if (slideBox && slideBox.__pfShow) slideBox.__pfShow($('img', el));
    if (el.closest('[data-pf-sg]')) openSG(null);
  });
})();
